<template lang="pug">
div
  #preloader(v-if="loading")
    #loader
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      loading: false
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
  },
  created() {
    var q = this.$route.query;
    this.paymentGateWaySubmit(q.amount, q.bank, q.promo, q.method);
  },
  methods: {
    paymentGateWaySubmit(deposit_amount, target_bank_id, package_id, method) {
      if(package_id === '0'){
        package_id = ""
      }  
      if (this.accountID && this.sessionToken) {
        this.loading =true
        let account_id = this.accountID;
        let auth_token = this.sessionToken;
        this.$store
          .dispatch("user/pepin", {
            account_id,
            deposit_amount,
            target_bank_id,
            package_id,
            auth_token,
            method
          })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success;
            this.feedback.status = response.status;
            if (this.feedback.success == true) {
              window.location.href= response.data
            } else {
              var vm = this;
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false;
            this.feedback.success = false;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
            }
            this.feedback.status = this.$t("error." + response.status);
          });
      }
    }
  }
};
</script>
